// ページごとに読み込まれるファイル

export default class ProfileMailSubscriptions {
  constructor(args) {
    // code
    console.log('profile_mail_subscriptions.js loaded')

    this.init()
  }

  // methods
  init() {
    this.mail_project_button = document.getElementById('mail_project_button');
    this.mail_project_holder = document.getElementById('mail_project_holder');

    this.mail_project_button.addEventListener('click', (e) => { this.onShowMailProject(); }, false);
  }

  onShowMailProject () {
    this.mail_project_holder.classList.toggle('is-active');
    this.mail_project_button.classList.add('is-hidden');
  }
}



// WEBPACK FOOTER //
// ./pages/profile_mail_subscriptions.js